// customer360 lives behind AttributeManagement.BackEnd (server.js) so the ecom
// bearer token never reaches the client bundle. Local dev backend runs on the
// PORT set in AttributeManagement.BackEnd/.env (5055 by default).
const MANAGEMENT_API_BASEURL =
  process.env.REACT_APP_API_BASEURL || "http://localhost:5055";

export async function fetchCustomers(searchTerm) {
  const params = new URLSearchParams();
  if (searchTerm) params.set("search", searchTerm);
  const query = `?${params.toString()}`;
  const response = await fetch(`${MANAGEMENT_API_BASEURL}/customers${query}`);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data?.details || data?.error || "Kunde inte h\u00e4mta kunder",
    );
  }
  return data;
}
